import { render, staticRenderFns } from "./UserTagScanner.vue?vue&type=template&id=2fe797fc&"
import script from "./UserTagScanner.vue?vue&type=script&lang=js&"
export * from "./UserTagScanner.vue?vue&type=script&lang=js&"
import style0 from "./UserTagScanner.vue?vue&type=style&index=0&id=2fe797fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports